export default {
    edit: 'Uredi',
    location: 'Lokacija + Uslovi korišćenja',
    filter: 'Filter',
};
